export const handleShowTYPE = (value) => {
    const contractTypeMap = {
        "lsfhp": "สัญญา 1",
        "vsfhp": "สัญญา 2",
        "psfhp": "สัญญา 3",
        "rpsl": "สัญญา 3(ใหม่)",
        "sfhp": "สัญญา 8",
    };
    return contractTypeMap[value] || "-";
};

export const handleShowTypeReply = (value) => {
    const typeReplyMap = {
        0: "บอกเลิก(เก่า)",
        1: "บอกกล่าวคนค้ำ",
        2: "สิทธิซื้อรถคืน(เก่า)",
        3: "แจ้งราคาขายรถ",
        4: "บอกเลิก",
        7: "บอกกล่าว(มือ)",
        44: "บอกเลิก(มือ)(ใหม่)",
        55: "บอกเลิก(มือ)",
        77: "สิทธิซื้อรถคืน",
        88: "แจ้งผลประมูล",
    };
    return typeReplyMap[value] || "-";
};


export function colorStatusDG(Status) {
    if (Status === 501) {
        return "green"
    } else if (Status === 401) {
        return "red"
    } else {
        return "orange"
    }
}

export function getStatusColor(status) {
    switch (status) {
        case 'ทั้งหมด': return 'blue';
        case 'บอกกล่าว': return 'cyan';
        case 'บอกกล่าว(มือ)': return 'cyan';
        case 'สิทธิซื้อรถคืน': return 'purple';
        case 'สิทธิซื้อรถคืน(เก่า)': return 'purple';
        case 'แจ้งราคาขายรถ': return 'orange';
        case 'บอกเลิก': return 'magenta';
        case 'บอกเลิก(มือ)': return 'magenta';
        case 'อยู่ระหว่างการนำจ่าย': return 'orange';
        case 'นำจ่ายไม่สำเร็จ': return 'red';
        case 'นำจ่ายสำเร็จ': return 'green';
        case 'รอคอนเฟิร์ม': return 'orange';
        case 'คอนเฟิร์มแล้ว': return 'green';
        case 'ตอบกลับ': return 'green';
        case 'ตีกลับ': return 'red';
        case 'ส่งถึงแล้วไม่ตอบกลับ': return 'purple';
        case 'แจ้งผลประมูล': return 'purple';
        case 'ไม่มีการเคลื่อนไหว': return 'default';

        default: return 'default';
    }
};

export function computeTabStatus(tabData) {
    const map = {};
    tabData.forEach(item => {
        ['status1', 'status2', 'status3', 'status4'].forEach(field => {
            const val = item[field];
            if (val) {
                if (!map[val]) map[val] = { status: val, nameStatus: val, totalCount: 0 };
                map[val].totalCount++;
            }
        });
    });
    return Object.values(map).filter(s => s.totalCount > 0);
};

export function getTypeReplyName(status) {
    switch (status) {
        case 1: return 'บอกกล่าว';
        case 2: return 'สิทธิซื้อรถคืน';
        case 3: return 'แจ้งราคาขายรถ';
        case 4: return 'บอกเลิก';
        case 5: return 'บอกเลิก(มือ)';
        case 88: return 'แจ้งผลประมูล';
        default: return '-';
    }
};